import { useCallback, useMemo, useState } from 'react'

export const useIsScrolledToBottom = (defaultIsScrolledToBottom = false) => {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(defaultIsScrolledToBottom)

  const handleScroll = useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      setIsScrolledToBottom(calculateIsScrolledToBottom(event.currentTarget))
    },
    [setIsScrolledToBottom]
  )

  const handleChange = useCallback(
    (el: HTMLDivElement) => {
      setIsScrolledToBottom(calculateIsScrolledToBottom(el))
    },
    [setIsScrolledToBottom]
  )

  return useMemo(
    () => ({ isScrolledToBottom, handleScroll, handleChange }),
    [isScrolledToBottom, handleScroll, handleChange]
  )
}

export const calculateIsScrolledToBottom = (element: HTMLDivElement) => {
  return Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <= 1
}
